module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-tabcontent"
  }, _vm._l((_vm.content.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "contact-tabcontent__item",
      attrs: {
        "id": "contact-tabcontent-" + i
      }
    }, [_c('div', {
      staticClass: "contact-tabcontent__content"
    }, [_c('div', {
      staticClass: "contact-tabcontent__left"
    }, [_c('img', {
      attrs: {
        "src": tab.tabcontent.image
      }
    })]), _c('div', {
      staticClass: "contact-tabcontent__right"
    }, [_c('div', {
      staticClass: "contact-tabcontent__hours"
    }, [_c('Icon', {
      attrs: {
        "name": "contact-hours"
      }
    }), _c('div', {
      staticClass: "contact-tabcontent__hours-content",
      domProps: {
        "innerHTML": _vm._s(tab.tabcontent.hours)
      }
    }, [_vm._v(_vm._s(tab.tabcontent.hours))])], 1), _c('a', {
      staticClass: "contact-tabcontent__addy",
      attrs: {
        "href": tab.tabcontent.map_link,
        "target": "_blank"
      }
    }, [_c('Icon', {
      attrs: {
        "name": "footer-pin"
      }
    }), _vm._v(_vm._s(tab.tabcontent.address_01)), _c('div', {
      staticClass: "contact-tabcontent__addy-city"
    }, [_vm._v(_vm._s(tab.tabcontent.address_02))])], 1), _c('a', {
      staticClass: "contact-tabcontent__phone",
      attrs: {
        "href": "tel:" + tab.tabcontent.phone_link
      }
    }, [_c('Icon', {
      attrs: {
        "name": "footer-phone"
      }
    }), _vm._v(_vm._s(tab.tabcontent.phone))], 1), (tab.tabcontent.fax) ? _c('div', {
      staticClass: "contact-tabcontent__phone"
    }, [_c('Icon', {
      attrs: {
        "name": "contact-appt"
      }
    }), _vm._v(_vm._s(tab.tabcontent.fax) + "  ")], 1) : _vm._e(), _c('div', {
      staticClass: "contact-tabcontent__email"
    }, [_c('div', {
      staticClass: "contact-tabcontent__email-title"
    }, [_vm._v("Emails")]), _c('a', {
      staticClass: "contact-tabcontent__email-ortho",
      attrs: {
        "href": "mailto:" + tab.tabcontent.ortho_email
      }
    }, [_c('Icon', {
      attrs: {
        "name": "contact-appt"
      }
    }), _vm._v("Orthodontic Appointments")], 1), _c('a', {
      staticClass: "contact-tabcontent__email-ped",
      attrs: {
        "href": "mailto:" + tab.tabcontent.ped_email
      }
    }, [_c('Icon', {
      attrs: {
        "name": "contact-appt"
      }
    }), _vm._v("Pediatric Dental Appointments")], 1), _c('a', {
      staticClass: "contact-tabcontent__email-npat",
      attrs: {
        "href": "mailto:" + tab.tabcontent.new_patient_email
      }
    }, [_c('Icon', {
      attrs: {
        "name": "contact-npat"
      }
    }), _vm._v("New Patient Inquiries")], 1), _c('a', {
      staticClass: "contact-tabcontent__email-fin",
      attrs: {
        "href": "mailto:" + tab.tabcontent.financial_email
      }
    }, [_c('Icon', {
      attrs: {
        "name": "contact-fin"
      }
    }), _vm._v("Financial Inquiries")], 1)])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33971ac2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-contact-tabs/contact-tabcontent/contact-tabcontent.pug
// module id = 625
// module chunks = 1